<template>
    <div class="collect">
        <Header ref="header" :title="title" :titleRight="titleRight" @backPage="onBack" @submit="onSubmit"></Header>
        <div v-if="myCollectList.length">
            <div class="cartList">
                <div class="cartTitle">
                    <van-list
                        v-model="loading"
                        :finished="finished"
                        :finished-text="finishHtml"
                        :immediate-check="false"
                        @load="onLoad"
                    >
                    <div class="cartLi" v-for="(item, index) in myCollectList" :key="index">
                        <div class="cart-left" v-show="radioFlase2">
                            <input class="doRadio" type="checkbox" name="sex" @click="onSelect(item)" :checked="item.isCheck">
                            <label></label>
                        </div>
                        <div class="col-cn" @click="onDetail(item)">
                            <div class="cart-center">
                                <img :src="item.pictureUrl" alt="">
                            </div>
                            <div class="cart-right">
                                <div class="title" :class="{'col999': !item.isForSale }">{{ item.spuName }}</div>
                                <!-- <div class="status" v-if="item.isForSale"><span>已售罄</span></div> -->
                                <div class="status" v-if="!item.isForSale"><span>失效</span></div>
                                <div class="buy">
                                    <div class="price">
                                        <sub>¥ </sub>{{ item.minPrice | NumFormat }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </van-list>
                </div>
            </div>
        </div>
        <div class="msg" v-else>
            <img src="../../../assets/img/b2b/tips.png" alt="">
            暂无收藏
        </div>
        <div class="footers" v-show="radioFlase2">
            <div class="footLeft">
                <input class="doRadio" type="checkbox" name="collect" @click="checkAll" :checked="checkAlls">
                <label>全选</label>
            </div>
            <div class="footRight">
                <div class="btn bgFF3B30" @click="onCancelCollect">取消收藏</div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
import { Dialog, Toast } from 'vant'
import Header from '../../common/header'
export default {
    name: 'myCollect',
    components: {
        Header
    },
    data () {
        return {
            title: '我的收藏',
            titleRight: '编辑',
            radioFlase2: false, // 编辑radio是否显示
            myCollectList: [],
            userInfo: '',
            finishHtml: '',
            finished: false,
            loading: false,
            total: 0,
            checkall: false,
            checked: [],
            memberCode: '',
            merchantCode: '',
            pageNumber: 1,
            pageSize: 5
        }
    },
    computed: {
        checkAlls () {
            let arrList = []
            this.myCollectList.forEach((item) => {
                if (item.isCheck) {
                    arrList.push(item)
                }
            })
            if (this.myCollectList.length === arrList.length) {
                return true
            } else {
                return false
            }
        }
    },
    methods: {
        ...mapActions([
            'getMyCollect',
            'cancelFavoriteData'
        ]),
        onBack () {
            this.$router.push({ path: '/b2b/order/index' })
        },
        onDetail (item) {
            if (this.radioFlase2 || !item.isForSale) {
                return false
            }
            localStorage.setItem('goodsDetailBack', this.$router.history.current.fullPath)
            this.$router.push({ path: '/b2b/goods/goodsDetail', query: { id: item.spuId } })
        },
        onSubmit () {
            this.radioFlase2 = !this.radioFlase2
            this.titleRight = this.radioFlase2 ? '完成' : '编辑'
        },
        checkAll () {
            let checkall = !this.checkAlls
            this.myCollectList.forEach((item) => {
                if (checkall) {
                    item.isCheck = true
                } else {
                    item.isCheck = false
                }
            })
        },
        onSelect (items) {
            items.isCheck = !items.isCheck
        },
        getAllCart () {
            let checkList = []
            this.myCollectList.forEach((item) => {
                if (item.isCheck) {
                    checkList.push(item.spuId)
                }
            })
            return checkList
        },
        onCancelCollect () {
            if (!this.getAllCart().length) {
                Toast('请选择商品')
                return false
            }
            Dialog.confirm({
                title: '',
                message: '是否取消收藏该商品？',
                confirmButtonColor: '#FF7A45',
                cancelButtonColor: '#FF7A45'
            }).then(() => {
                this.delCollectData()
            }).catch(() => {
                // on cancel
            })
        },
        async delCollectData () {
            await this.cancelFavoriteData({
                memberCode: this.userInfo.companyCode,
                operator: this.userInfo.id,
                productIds: this.getAllCart()
            }).then((data) => {
                this.pageNumber = 1
                this.loading = false
                this.finished = false
                this.myCollectList = []
                this.getMyCollectData()
                this.onSubmit()
            })
        },
        onLoad () {
            this.pageNumber += 1
            this.getMyCollectData()
        },
        async getMyCollectData () {
            await this.getMyCollect({
                memberCode: this.userInfo.companyCode,
                merchantCode: this.userInfo.belongMerchantCode,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize
            }).then((data) => {
                let dataArr = data.records
                if (!dataArr.length) {
                    this.myCollectList = []
                    this.titleRight = ''
                    return false
                }
                for (let i = 0; i < dataArr.length; i++) {
                    dataArr[i]['isCheck'] = false
                }
                this.myCollectList = this.myCollectList.concat(dataArr)
                this.loading = false
                this.disClick = true
                if (this.myCollectList.length >= data.total) {
                    this.finished = true
                }
                if (data.total > this.myCollectList.length) {
                    this.finishHtml = '已经到底了'
                }
            })
        }
    },
    mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.getMyCollectData()
    }
}
</script>
<style lang="scss" scoped>
    .collect{
        background: #f5f5f5;
        height: 100%;
        font-size: 28px;
        // padding: 20px 24px;
        // padding-bottom: 250px;
        box-sizing: border-box;
        .cartList{
            padding: 20px 24px;
            background: #f5f5f5;
            .cartTitle{
                padding-bottom: 120px;
            }
            .h3{
                text-align: right;
                padding: 24px;
                color: #FF7A45
            }
            .cartLi{
                display: flex;
                justify-content: flex-start;
                &.pLeft0{
                    padding-left: 0;
                    .ct{
                        margin: 0;
                        flex: 0 0 88px;
                        span{
                            font-size: 24px;
                            width: 72px;
                            height: 34px;
                            line-height: 34px;
                            text-align: center;
                            display: block;
                            color: #ffffff;
                            background: #aaaaaa;
                            border-radius: 34px;
                            margin: 0 8px;
                        }
                    }
                }
                .cart-left{
                    padding-top: 130px;
                    margin-right: 10px;
                    input{
                        position: absolute;
                        margin: 0;
                    }
                }
                .col-cn{
                    width: 100%;
                    display: flex;
                    justify-content: flex-start;
                    background: #ffffff;
                    border-radius: 12px;
                    padding: 24px;
                    margin-bottom: 20px;
                    .cart-center{
                        width: 280px;
                        height: 280px;
                        flex: 0 0 280px;
                        position: relative;
                        img{
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            -webkit-transform: translate(-50%,-50%);
                            -moz-transform: translate(-50%,-50%);
                            transform:translate(-50%,-50%);
                        }
                    }
                    .cart-right{
                        display: flex;
                        align-content: space-between;
                        flex-wrap: wrap;
                        margin-left: 24px;
                        .title{
                            line-height:40px;
                            flex: 0 0 100%;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                            white-space: normal;
                            word-break: break-all;
                        }
                        .status{
                            flex: 0 0 100%;
                            font-size: 24px;
                            span{
                                color: #ffffff;
                                display: inline-block;
                                width: 114px;
                                text-align: center;
                                height: 50px;
                                line-height: 50px;
                                border-radius: 50px;
                                background: #aaaaaa;
                            }
                        }
                        .buy{
                            flex: 0 0 100%;
                            height: 60px;
                            display: flex;
                            justify-content: space-between;
                            .price{
                                margin-top: 18px;
                                color: #FF7A45;
                                font-size: 30px;
                                sub{
                                    font-size: 20px;
                                }
                                span{
                                    font-size: 24px;
                                    color: #999999;
                                    text-decoration: line-through;
                                    margin-left: 20px;
                                    sub{
                                        font-size: 16px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .msg{
            width: 182px;
            font-size: 26px;
            color: #c7c7cc;
            margin: 0 auto;
            padding-top: 160px;
            text-align: center;
            img{
                width: 176px;
                height: 176px;
                margin: 0 auto;
            }
        }
        .footers{
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            display: flex;
            justify-content: space-between;
            padding: 32px 24px;
            background: #ffffff;
            height: 64px;
            line-height: 64px;
            .footLeft{
                input{
                    position: absolute;
                    margin: 0;
                }
                label{
                    color: #666666;
                    padding-top: 12px;
                }
            }
            .footRight{
                display: flex;
                justify-content: flex-end;
                .price{
                    position: relative;
                    font-size: 30px;
                    span{
                        color: #FF7A45;
                        sub{
                            font-size: 20px;
                        }
                    }
                    sup{
                        position: absolute;
                        bottom: -26px;
                        right: 0;
                        font-size: 24px;
                        color: #999999;
                    }
                }
                .btn{
                    width: 208px;
                    background: #FF7A45;
                    border-radius: 64px;
                    text-align: center;
                    color: #ffffff;
                    margin-left: 20px;
                }
            }
        }
        .loading{
            color: #999;
            text-align: center;
            padding: 40px;
        }
    }
</style>